export default "__VITE_ASSET__52e47682__"